import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root'
})
export class ConsultaService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  getListTrazabilidadDocumentos(numint: number) {
    return this.http.get(environment.serviceUrl + "trazabilidad/trazabilidadDoc?numint=" + numint, { observe: 'response' })
  }

  getListTrazabilidadDocumentos2(numint: number) {
    return this.http.get(environment.serviceUrl + "trazabilidad/trazabilidadDoc_v2?numint=" + numint, { observe: 'response' })
  }


  getdownloadArchivosAdjuntos(numint: number, item: number) {
    return this.http.get(environment.serviceUrl + "archivos/download/adjuntos?numint=" + numint + "&item=" + item, { observe: 'response' })
  }

  getArchivosAdjuntos(numint: number) {
    return this.http.get(environment.serviceUrl + "archivos/adjuntos?numint=" + numint, { observe: 'response' },)
  }

  getListTransaccionLogDocumentos(numint: number) {
    return this.http.get(environment.serviceUrl + "trazabilidad/transaccionesLog?numint=" + numint, { observe: 'response' },)

  }



  buscarUsuarios(coduser: string, nombres: string, activo: boolean) {
    const fullUrl = environment.serviceUrl + `usuario/buscar?coduser=${encodeURI(coduser)}&nombres=${encodeURI(nombres)}&activo=${activo}`;
    return this.http.get(fullUrl);
  }

  public buscarAsistencia(finicio: string, ffinal: any) {
    const fullUrl = environment.serviceUrl + `asistencia/buscar?finicio=${finicio}` + "&ffinal=" + ffinal;
    return this.http.get(fullUrl);
  }

  public importaTcambio(fecha: any) {
    return this.http.get("https://api.apis.net.pe/v1/tipo-cambio-sunat?fecha=" + fecha);
  }


  buscarDocumentos(tipdoc: number, vParams: any) {
    if (tipdoc == 1) {
      return this.http.get(environment.serviceUrl + "factura/buscar" +
        "?situac=" + encodeURIComponent(vParams.situac) +
        "&codsuc=" + vParams.codsuc +
        "&codcli=" + encodeURIComponent(vParams.codcli) +
        (vParams.fdesde != null ? ("&fdesde=" + vParams.fdesde) : "") +
        (vParams.fhasta != null ? ("&fhasta=" + vParams.fhasta) : "") +
        (vParams.limit != null ? ("&limit=" + vParams.limit) : "") +
        (vParams.offset != null ? ("&offset=" + vParams.offset) : ""), { observe: "response" });
    } else if (tipdoc == 3) {
      return this.http.get(environment.serviceUrl + "boleta/buscar" +
        "?situac=" + encodeURIComponent(vParams.situac) +
        "&codsuc=" + vParams.codsuc +
        "&codcli=" + encodeURIComponent(vParams.codcli) +
        (vParams.fdesde != null ? ("&fdesde=" + vParams.fdesde) : "") +
        (vParams.fhasta != null ? ("&fhasta=" + vParams.fhasta) : "") +
        (vParams.limit != null ? ("&limit=" + vParams.limit) : "") +
        (vParams.offset != null ? ("&offset=" + vParams.offset) : ""), { observe: "response" });
    } else if (tipdoc == 100) {
      return this.http.get(environment.serviceUrl + "cotizacion/buscar" +
        "?situac=" + encodeURIComponent(vParams.situac) +
        "&codsuc=" + vParams.codsuc +
        "&codcli=" + encodeURIComponent(vParams.codcli) +
        "&codven=" + vParams.codven +
        "&lugemi=" + vParams.lugemi +
        (vParams.fdesde != null ? ("&fdesde=" + vParams.fdesde) : "") +
        (vParams.fhasta != null ? ("&fhasta=" + vParams.fhasta) : "") +
        (vParams.limit != null ? ("&limit=" + vParams.limit) : "") +
        (vParams.offset != null ? ("&offset=" + vParams.offset) : ""), { observe: "response" });
    } else if (tipdoc == 101) {
      return this.http.get(environment.serviceUrl + "ordenPedido/buscar" +
        "?situac=" + encodeURIComponent(vParams.situac) +
        "&codsuc=" + vParams.codsuc +
        "&codcli=" + encodeURIComponent(vParams.codcli) +
        "&codven=" + vParams.codven +
        "&lugemi=" + vParams.lugemi +
        (vParams.fdesde != null ? ("&fdesde=" + vParams.fdesde) : "") +
        (vParams.fhasta != null ? ("&fhasta=" + vParams.fhasta) : "") +
        (vParams.limit != null ? ("&limit=" + vParams.limit) : "") +
        (vParams.offset != null ? ("&offset=" + vParams.offset) : ""), { observe: "response" });
    } else {
      return null;
    }




  }


  buscarDocumentos_v2(vParams: any) {

    return this.http.get(environment.serviceUrl + "consultas/comprobantes" +
      "?situac=" + encodeURIComponent(vParams.situac) +
      "&codsuc=" + vParams.codsuc +
      "&codcli=" + encodeURIComponent(vParams.codcli) +
      (vParams.codven != null ? ("&codven=" + vParams.codven) : "") +
      (vParams.lugemi != null ? ("&lugemi=" + vParams.lugemi) : "") +
      (vParams.estadoSunat != null ? ("&estadoSunat=" + vParams.estadoSunat) : "") +
      (vParams.codmot != null ? ("&codmot=" + vParams.codmot) : "") +
      (vParams.tipdoc != null ? ("&tipdoc=" + vParams.tipdoc) : "") +
      (vParams.destino != null ? ("&destino=" + vParams.destino) : "") +
      (vParams.fdesde != null ? ("&fdesde=" + vParams.fdesde) : "") +
      (vParams.fhasta != null ? ("&fhasta=" + vParams.fhasta) : "") +
      (vParams.limit != null ? ("&limit=" + vParams.limit) : "") +
      (vParams.offset != null ? ("&offset=" + vParams.offset) : ""), { observe: "response" });
  }




  buscarDocumentosParaDocOrigen(
    tipdoc: number,
    moneda: string,
    codsuc: number,
    codcli: string) {
    return this.http.get(environment.serviceUrl + "documentoCab/buscar-docs-cred_or_debit" +
      "?tipdoc=" + tipdoc +
      "&codsuc=" + codsuc +
      "&moneda=" + moneda +
      "&codcli=" + codcli, { observe: "response" });
  }


  buscarAnticipos(codcli: string, incigv: string) {
    return this.http.get(environment.serviceUrl + "control-anticipos/sp000_saca_saldo_dcta106_codcli" +
      "?codcli=" + encodeURIComponent(codcli)
      + "&incigv=" + (incigv == "true" ? "S" : "N"), { observe: "response" });
  }

   buscarAnticipos2(codcli:any,situac:any,detapl:any,fdesde:any,fhasta:any){
       this.apiService.setUrlPathApi('consultas/anticipos');
        return this.apiService.execGetQueryJson(`?codcli=${codcli}&situac=${situac}&detapl=${detapl}&fdesde=${fdesde}&fhasta=${fhasta}`).pipe();
   }
}
